export default __webpack_public_path__ + "static/Week-4-City Sweetheart-Homepage-Banner-mobile-a5a20d33e9fb0a5fa653d67fd6b7cc8c.webp";